import { loadState, saveState } from '@map/localStorage';
import { storeLoaded } from '@map/state/storeService';
import { createReduxStore } from '@shared/lib/redux';
import { throttle } from '@shared/util/function';
import { getRequestedLocale } from '@shared/util/locale';
import rootReducer from './rootReducer';

const initialState = { storeService: { ready: false } };

const store = createReduxStore(rootReducer, initialState as any);

type StoreState = ReturnType<typeof rootReducer>;
loadState().then((loaded: StoreState | undefined) => {
  const state = (loaded || initialState) as Partial<StoreState>;
  const requestedLocale = getRequestedLocale();
  if (!state.user?.id && requestedLocale) {
    state.user = { ...state.user, locale: requestedLocale };
  }
  const data = {
    ...state,
    dataState: loaded ? ('stale' as const) : ('empty' as const),
    storeService: { ready: true },
  };
  store.dispatch(storeLoaded(data));
});

export const persistStoreState = async () => {
  // clean out unserializable data from store
  const {
    storeService,
    // disabling eslint here, since we'd have to alias all of those properties
    /* eslint-disable @typescript-eslint/no-unused-vars */
    // help visibility should be reset
    help,
    // notifications should be reset
    notifications,
    appVersion,
    /* eslint-enable @typescript-eslint/no-unused-vars */
    ...state
  } = store.getState();
  if (storeService.ready) {
    await saveState(state);
  }
};
store.subscribe(throttle(persistStoreState, 1000));
export default store;
